import React from 'react'

import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import { MoreVert } from '@mui/icons-material'
import { usePopoverState } from '@collaborate-health/uikit'

export interface ActionsMenuOption<T extends { Id: number }> {
  name: string
  onClick: (model: T) => void
  isDisabled?: boolean | ((model: T) => boolean)
  icon: React.ReactNode
  renderCondition?: (model: T) => boolean
}

interface ActionsMenuProps<T extends { Id: number }> {
  model: T
  options: ActionsMenuOption<T>[]
}

const ActionsMenu = <T extends { Id: number }>({ model, options }: ActionsMenuProps<T>) => {
  const [anchorRef, open, onOpen, onClose] = usePopoverState()

  const handleMenuItemClick = (option: ActionsMenuOption<T>) => {
    option.onClick(model)
    onClose()
  }

  return (
    <div>
      <IconButton ref={anchorRef} onClick={onOpen}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            minWidth: '20ch',
          },
        }}
      >
        {options
          .filter((option) => {
            return option.renderCondition ? option.renderCondition(model) : true
          })
          .map((option) => (
            <MenuItem
              key={`${model.Id}_${option.name}`}
              disabled={typeof option.isDisabled === 'function' ? option.isDisabled(model) : option.isDisabled}
              onClick={() => handleMenuItemClick(option)}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText>{option.name}</ListItemText>
            </MenuItem>
          ))}
      </Menu>
    </div>
  )
}

export default ActionsMenu

